import React, { useContext, useEffect, useState, useCallback } from 'react';
import { Link } from 'react-router-dom'
import fetchHook from '../../hooks/fetchMSSQL-hook';
import { NavigationContext } from '../../context/navigation-context';
import { LangContext } from '../../context/lang-context';
import formHook from '../../hooks/form-hook';
import NoResults from '../../components/NoResults/NoResults';
import { NotificationManager } from 'react-notifications';
import DepositForm from '../../components/Modals/DepositForm';
import SearchFilter from "../../components/Filter/SearchFilter";

export default function Deposits() {
  const { fetchMssqlApi } = fetchHook();
  const { setHeaderData } = useContext(NavigationContext);
  const { TRL_Pack } = useContext(LangContext);
  const { form, openForm, closeForm } = formHook();
  const [deposits, setDeposits] = useState([]);
  const [windowHeight, setWindowHeight] = useState(window.innerHeight);
  
  const defaultFilter = {
    page: 1,
    rowsPerPage: 100,
    sortBy: "none",
    isActive: "true",
  };

  const [filter, setFilter] = useState(defaultFilter);
    const [settingsFilter, setSettingsFilter] = useState({
      saveFilters: true,
      autoLoading: true,
      additionalFilter: true,
      flatView: false,
      rowsPerPage: 50,
    });

  const rowsPerPage = settingsFilter.rowsPerPage || filter.rowsPerPage || 50;

  const sortDefaults = {
    Name: "ASC",
    EAN: "ASC",
    Price: "DESC",
    IsActive: "DESC",
  };

  const getSortState = () => {
    const [field, dir] = String(filter.sortBy || "").split("|");
    return { field, dir: (dir || "").toUpperCase() };
  };

  const sortState = getSortState();

  const arrow = (field) => {
    if (sortState.field !== field) return "";
    return sortState.dir === "ASC" ? " ▲" : " ▼";
  };


  const handleHeaderSort = (field) => {
    const [curField, curDirRaw] = String(filter.sortBy || "none").split("|");
    const curDir = (curDirRaw || "").toUpperCase();
    let sortBy;
    let sortByName=""
    if (curField !== field) {sortBy = `${field}|DESC`;
    } else if (curDir === "DESC") {sortBy = `${field}|ASC`;
    } else if (curDir === "ASC") {sortBy = "none";
    } else sortBy = `${field}|DESC`;
    const next = { ...filter, sortBy, page: 1 };
    setFilter(next);
    search(next, settingsFilter.rowsPerPage, 1, true);
  };

  const parseThreeState = (val) => {
    if (val === "true") return true;
    if (val === "false") return false;
    return null 
  }

  const search = (f) => {
    fetchMssqlApi('deposits', {
      method: "POST",
      hideNotification: true,
      data: {
        isActive: parseThreeState(f?.isActive),
        sortBy: f?.sortBy,
      }
    }, res => {
      setDeposits(res || []);
    });
  };

  const handleSubmit = (evt) => {
    evt.preventDefault();
    const { name, ean, price } = evt.target.elements;
    const payload = {
      Name: name.value.trim(),
      EAN: ean.value ? Number(ean.value) : null,
      Price: price.value ? Number(price.value) : 0,
    };

    if (!payload.Name) {
      NotificationManager.error('Nazwa jest wymagana');
      return;
    }
    if (!payload.EAN || isNaN(payload.EAN)) {
      NotificationManager.error('EAN musi być liczbą');
      return;
    }
    if (payload.Price < 0) {
      NotificationManager.error('Cena nie może być ujemna');
      return;
    }

    if (form === 'new') {
      fetchMssqlApi(
        'deposit',
        { method: 'POST', data: payload },
        () => {
          search(filter);
          closeForm();
        }
      );
    } else {
      const submitter = evt.nativeEvent?.submitter;
      const fromToggle = submitter?.id === 'isActive';

      if (fromToggle) {
        const current = deposits.find(d => d.DepositId === form);
        const nextIsActive = !Boolean(current?.IsActive);
        return fetchMssqlApi(
          `deposit/${form}`,
          { method: 'PUT', data: { ...current, IsActive: nextIsActive } },
          () => { 
            search(filter); 
            closeForm(); 
          }
        );
      }
      fetchMssqlApi(
        `deposit/${form}`,
        { method: 'PUT', data: {
          EAN: payload.EAN,
          Name: payload.Name,
          Price: payload.Price,
          IsActive: 1} },
        () => {
          search(filter);
          closeForm();
        }
      );
    }
  };

  useEffect(() => {
    setHeaderData({ text: 'Kaucje' });
  }, []);

  const handleSearchFilterChange = useCallback((f) => {
    setFilter(prev =>
      JSON.stringify(prev || {}) === JSON.stringify(f || {}) ? prev : f
    );
  }, []);

  return (
    <div>
      <ul className="nav nav-tabs machine-tabs mb-1">
        <li className="nav-item">
          <Link to="/products">
            <button className={`nav-link btn`} tabIndex="0">
              Produkty
            </button>
          </Link>
        </li>
        {(process.env.REACT_APP_LOCAL_DB === "false") && (
          <li className="nav-item">
            <Link to="/recipes">
              <button className={`nav-link btn`} tabIndex="0">
                Receptury
              </button>
            </Link>
          </li>
        )}
        <li className="nav-item">
          <Link to="/categories">
            <button className={`nav-link btn`} tabIndex="0">
              Kategorie
            </button>
          </Link>
        </li>
        <li className="nav-item">
          <Link to="/deposits">
            <button className={`nav-link btn active`} tabIndex="0">
              Kaucje
            </button>
          </Link>
        </li>
      </ul>
      <SearchFilter
        filterName="deposits"
        defaultFilter={defaultFilter}
        searchFilter={filter}
        onFilterChange={handleSearchFilterChange}
        onSettingsChange={(s) => setSettingsFilter(prev => ({ ...prev, ...s }))}
        search={search}
        totalCount={deposits.slice((filter.page - 1) * rowsPerPage, filter.page * rowsPerPage).length}
        dataList={deposits}
        forNow
      />
      <div className="border">
        <div
          className="custom-scroll overflow-auto"
          style={{ maxHeight: "calc(100vh - 170px)" }}
        >
          <table className="table table-striped">
            <thead className="headers-stick-machines">
              <tr>
                <th
                  className="text-center"
                  style={{ cursor: "pointer", userSelect: "none" }}
                  onClick={() => handleHeaderSort("Name")}
                >
                  Nazwa{arrow("Name")}
                </th>
                <th
                  className="text-center"
                  style={{ cursor: "pointer", userSelect: "none" }}
                  onClick={() => handleHeaderSort("EAN")}
                >
                  EAN{arrow("EAN")}
                </th>
                <th
                  className="text-center"
                  style={{ cursor: "pointer", userSelect: "none" }}
                  onClick={() => handleHeaderSort("Price")}
                >
                  Cena{arrow("Price")}
                </th>
                <th
                  className="text-center"
                  style={{ cursor: "pointer", userSelect: "none" }}
                  onClick={() => handleHeaderSort("IsActive")}
                >
                  Aktywny{arrow("IsActive")}
                </th>

                <th className="p-2 align-middle" style={{ width: "100px" }}>
                  <div className="d-flex flex-column align-items-center">
                    <i
                      className="btn btn-outline-primary fas fa-plus"
                      onClick={openForm()}
                    />
                  </div>
                </th>
              </tr>
            </thead>
            <tbody>
              {deposits
                .slice((filter.page - 1) * rowsPerPage, filter.page * rowsPerPage)
                .map((dep) => (
                  <tr key={dep.DepositId}>
                    <td className="text-center" style={{ wordBreak: "break-word" }}>
                      {dep.Name}
                    </td>
                    <td className="text-center">{dep.EAN}</td>
                    <td className="text-center">
                      {Number(dep.Price).toFixed(2)} zł
                    </td>
                    <td className="text-center"><i className={dep.IsActive ? "fas fa-check-square text-primary" : "far fa-square text-primary"}/></td>
                    <td className="text-center">
                      <button
                        className="btn btn-outline-primary"
                        onClick={openForm(dep.DepositId)}
                      >
                        Edytuj
                      </button>
                    </td>
                  </tr>
                ))}
            </tbody>
          </table>
          {deposits?.length === 0 && <NoResults />}
        </div>
      </div>
    {form && (
      <DepositForm
        depositData={deposits.find(d => d.DepositId === form)}
        handleClose={closeForm}
        handleSubmit={handleSubmit}
      />
    )}
    </div>
  );
}